import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
const taban = 'flex h-11 w-full rounded-lg border border-fume-200 bg-white px-3.5 py-2 text-sm text-fume-900 placeholder:text-fume-400 transition focus:outline-none focus:ring-2 focus:ring-marka-500 focus:border-marka-500 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-fume-900 dark:border-fume-700 dark:text-fume-50 dark:placeholder:text-fume-500';
export const Girdi = forwardRef(({ className, ...rest }, ref) => {
    return _jsx("input", { ref: ref, className: cn(taban, className), ...rest });
});
Girdi.displayName = 'Girdi';
//# sourceMappingURL=girdi.js.map